import { useState } from 'react';

export type TrackerExportType = 'jira' | 'github';

type UseTrackerExportPickerReturn = {
  trackerType: TrackerExportType;
  onTrackerTypeChange: (trackerType: TrackerExportType) => void;
};

//  Determine the initially selected tracker type.
const getInitialState = (hasJiras: boolean, hasGitHub: boolean): TrackerExportType => {
  if (hasJiras) {
    return 'jira';
  }
  if (hasGitHub) {
    return 'github';
  }
  //  This case technically wouldn't happen because the component
  //  is only rendered if there is either Jiras or a GitHub.
  return 'jira';
};

/**
 * Simple hook which manages the state of the "tracker picker"
 *
 * @param {boolean} hasJiras - If there are jiras enabled.
 * @param {boolean} hasGitHub - If the project is a GitHub import.
 */
const useTrackerExportPicker = (hasJiras: boolean, hasGitHub: boolean): UseTrackerExportPickerReturn => {
  const [trackerType, setTrackerType] = useState<TrackerExportType>(
    getInitialState(hasJiras, hasGitHub),
  );
  return {
    trackerType,
    onTrackerTypeChange: setTrackerType,
  };
};

export default useTrackerExportPicker;
